export enum EscalationLevel {
    S0 = 0, /* offline */
    S1 = 1, /* fließverkehr */
    S2 = 2,
    S3 = 3,
    S4 = 4,
    S5 = 5,
    /*     S6 = 6,
        S7 = 7,
        S8 = 8,
        S9 = 9,
        S10 = 10,
        S15 = 15, */
    S20 = 20,
    S30 = 30
    /*  S40 = 40,
     S50 = 50,
     S100 = 100 */
}

export function getEscalationLevelString(escalationLevel: EscalationLevel): string {
    switch (escalationLevel) {
        case EscalationLevel.S0:
            return 'Off';
        case EscalationLevel.S1:
            return 'Fließverkehr';
        case EscalationLevel.S2:
            return 'Harmonisierung 120 km/h';
        case EscalationLevel.S3:
            return 'Harmonisierung 100 km/h';
        case EscalationLevel.S4:
            return 'Harmonisierung 80 km/h';
        case EscalationLevel.S5:
            return 'Harmonisierung 60 km/h';
            /*    case EscalationLevel.S6:
                   return 'S6';
               case EscalationLevel.S7:
                   return 'S7';
               case EscalationLevel.S8:
                   return 'S8';
               case EscalationLevel.S9:
                   return 'S9';
               case EscalationLevel.S10:
                   return 'S10';
               case EscalationLevel.S15: 
            return 'S15';*/
        case EscalationLevel.S20:
            return 'zäher Verkehr';
        case EscalationLevel.S30:
            return 'Stau';
        /*   case EscalationLevel.S40:
              return 'S40';
          case EscalationLevel.S50:
              return 'S50';
          case EscalationLevel.S100:
              return 'S100'; */
    }
}

export function getEscalationLevelSelect(): { name: string, id: number }[] {
    return [
        { name: getEscalationLevelString(EscalationLevel.S0), id: 0 },
        { name: getEscalationLevelString(EscalationLevel.S30), id: 30 },
        { name: getEscalationLevelString(EscalationLevel.S20), id: 20 },
        { name: getEscalationLevelString(EscalationLevel.S1), id: 1 },
        { name: getEscalationLevelString(EscalationLevel.S2), id: 2 },
        { name: getEscalationLevelString(EscalationLevel.S3), id: 3 },
        { name: getEscalationLevelString(EscalationLevel.S4), id: 4 },
        { name: getEscalationLevelString(EscalationLevel.S5), id: 5 },
        /*      { name: getEscalationLevelString(EscalationLevel.S6), id: 6 },
             { name: getEscalationLevelString(EscalationLevel.S7), id: 7 },
             { name: getEscalationLevelString(EscalationLevel.S8), id: 8 },
             { name: getEscalationLevelString(EscalationLevel.S9), id: 9 },
             { name: getEscalationLevelString(EscalationLevel.S10), id: 10 },
             { name: getEscalationLevelString(EscalationLevel.S15), id: 15 }, */


        /*       { name: getEscalationLevelString(EscalationLevel.S40), id: 40 },
              { name: getEscalationLevelString(EscalationLevel.S50), id: 50 },
              { name: getEscalationLevelString(EscalationLevel.S100), id: 100 } */
    ];
}
